// extracted by mini-css-extract-plugin
module.exports = {"description":"description_description__15kxD"};